module.exports = __webpack_public_path__ + "static/media/aa1.35504c22.jpeg";